module.exports = __webpack_public_path__ + "img/管理-1.3fbee2de.jpg";